<!-- src/pages/dashboard/index.vue -->
<template>
  <div class="bg-light min-vh-100">

    <!-- Navbar Top -->
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
      <div class="container-fluid">
        <a class="navbar-brand fw-bold" href="#">
          <i class="bi bi-lightning-charge"></i> NeXt Instalações
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarMenu">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            <li class="nav-item" v-for="item in topMenu" :key="item.name">
              <a class="nav-link" :href="item.link">
                <i :class="item.icon"></i> {{ $t(item.label) }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Conteúdo -->
    <div class="container py-5 mt-4">
      <h3 class="mb-4 text-center">{{ $t('dashboard.welcome') }}</h3>

      <div class="row g-2 justify-content-center">
        <div class="col-4 col-md-3" v-for="card in cards" :key="card.name">
          <a :href="card.link" class="card card-menu text-center p-3 position-relative">
            <span v-if="card.badge" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
              {{ card.badge }} <span class="visually-hidden">{{ card.badgeLabel }}</span>
            </span>
            <div class="icon-box mb-2"><i :class="card.icon"></i></div>
            <h6 class="fw-bold">{{ $t(card.label) }}</h6>
          </a>
        </div>
      </div>
    </div>

    <!-- Bottom Navbar - mobile only -->
    <nav class="navbar navbar-dark bg-primary navbar-expand d-lg-none fixed-bottom">
      <ul class="navbar-nav nav-justified w-100 align-items-center">
        <li class="nav-item" v-for="item in bottomMenu" :key="item.name">
          <a :href="item.link" class="nav-link text-center" :class="item.central ? 'bg-white rounded-circle shadow' : ''"
             :style="item.central ? 'margin-top:-30px; width:60px; height:60px; display:flex; align-items:center; justify-content:center; border:3px solid #0d6efd;' : ''">
            <i :class="item.icon" class="fs-4" :style="item.central ? 'font-size:1.5rem; color:#0d6efd;' : ''"></i><br>
            <small v-if="!item.central">{{ $t(item.label) }}</small>
          </a>
        </li>
      </ul>
    </nav>

  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

// Top navbar links
const topMenu = ref([
  { name: 'home', label: 'dashboard.menu.home', link: '#', icon: 'fa-solid fa-house' },
  { name: 'os', label: 'dashboard.menu.services', link: '#', icon: 'bi bi-clipboard-check' },
  { name: 'reports', label: 'dashboard.menu.reports', link: '#', icon: 'bi bi-bar-chart-line' },
  { name: 'budgets', label: 'dashboard.menu.budgets', link: '#', icon: 'bi bi-cash-coin' },
  { name: 'support', label: 'dashboard.menu.support', link: '#', icon: 'bi bi-headset' },
]);

// Dashboard cards
const cards = ref([
  { name: 'budgets', label: 'dashboard.cards.budgets', link: '#', icon: 'fa-solid fa-file-pen' },
  { name: 'services', label: 'dashboard.cards.services', link: '#', icon: 'fa-solid fa-screwdriver-wrench' },
  { name: 'daily', label: 'dashboard.cards.daily', link: '#', icon: 'fa-solid fa-clipboard-check', badge: 5, badgeLabel: 'dashboard.cards.daily_badge' },
  { name: 'projects', label: 'dashboard.cards.projects', link: '#', icon: 'fa-solid fa-layer-group' },
  { name: 'finance', label: 'dashboard.cards.finance', link: '#', icon: 'fa-solid fa-money-check-dollar' },
  { name: 'material', label: 'dashboard.cards.material', link: '#', icon: 'fa-solid fa-boxes-packing' },
  { name: 'gallery', label: 'dashboard.cards.gallery', link: '#', icon: 'fa-solid fa-photo-film' },
  { name: 'live', label: 'dashboard.cards.live', link: '#', icon: 'fas fa-video' },
  { name: 'support', label: 'dashboard.cards.support', link: '#', icon: 'fa-solid fa-phone-volume' },
]);

// Bottom navbar links
const bottomMenu = ref([
  { name: 'home', label: 'Início', link: '#', icon: 'fa-solid fa-house', central: false },
  { name: 'os', label: 'O.S.', link: '#', icon: 'fa-solid fa-house', central: false },
  { name: 'qr', label: 'QR Code', link: '#', icon: 'fa-solid fa-house', central: true },
  { name: 'budgets', label: 'Serviços', link: '#', icon: 'fa-solid fa-house', central: false },
  { name: 'profile', label: 'Perfil', link: '#', icon: 'fa-solid fa-house', central: false },
]);
</script>

<style scoped>
body {
  padding-top: 70px;
  padding-bottom: 80px;
}

.card-menu {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
}
.card-menu:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0,0,0,0.15);
  color: inherit;
}

h6.fw-bold {
  font-size: clamp(0.8rem, 2vw, 1rem);
}

.icon-box {
  font-size: 3rem;
  color: #0d6efd;
}
</style>
